// Import: Middleware Action & Custom Types
import { CLEAN_CONSULT_LEGAL_ID, CLEAN_CONSULT_LEGAL_ID_ERROR } from '_models/redux/types';

// Action function
export const cleanConsultLegalId = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_CONSULT_LEGAL_ID,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_CONSULT_LEGAL_ID_ERROR,
    });
  }
};
